
import { defineComponent, PropType } from 'vue'

import Cheap from '@/common/components/UI/Cheap/index.vue'
import { computed } from 'vue'
import { LtlStatusColors } from '@/core/constants/columns/LTL.columns'

import { formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
    },
    components: { Cheap },
    setup(props) {
        const getCheapClass = computed(() => {
            if (!props.row || !props.row.status) return ''

            const { id } = props.row.status

            if (LtlStatusColors[id]) return LtlStatusColors[id]
            else if (id === 51) return 'red'
            else if (![1, 4].includes(id)) return 'yellow'

            return ''
        })

        return { getCheapClass, formatDateWithTimeFromBackend }
    },
})
